import { JobStatus } from 'interfaces/job';
import { SlideTileGenerationStatus } from 'interfaces/tileGeneration';
import { isTileGenerationActive } from 'utils/queryHooks/useSlidesTileGenerationStatus';

export type TileGenerationState = 'active' | 'ready' | 'failed';

export interface TileGenerationPresentation {
  state: TileGenerationState;
  text: string;
  /** Known percent while tiles are generating; undefined when the worker has not reported one. */
  percent?: number;
}

export const getTileGenerationPresentation = (status: SlideTileGenerationStatus): TileGenerationPresentation => {
  if (isTileGenerationActive(status.status)) {
    if (status.progress) {
      return { state: 'active', text: status.progress.message, percent: status.progress.percent };
    }
    return {
      state: 'active',
      text: status.status === JobStatus.Pending ? 'Waiting to start' : status.statusMessage || 'Generating tiles',
    };
  }
  if (status.status === JobStatus.Completed) {
    return { state: 'ready', text: 'Tiles ready' };
  }
  return {
    state: 'failed',
    text: status.statusMessage || 'Tile generation failed',
  };
};
